import { Fragment,useState } from 'react'


const Welcome = ({title, submitter }) => {
   return (<><h2>Welcome</h2>
   <p>This is the OSM Road Monitor platform developed by TUM Big Geospatial Data Management in collaboration with HeiGIT gGmbH and University of Heidelberg.
</p>
</>);
};
export default Welcome;